var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExitCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "#5E639B",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0811 10.6627L7.82943 6.41099L12.0701 2.17034C12.459 1.78143 12.459 1.14503 12.0701 0.756122C11.6812 0.367213 11.0448 0.367213 10.6559 0.756122L6.41522 4.99677L2.18562 0.76717C1.79671 0.378261 1.16031 0.378261 0.771404 0.76717C0.382495 1.15608 0.382495 1.79247 0.771404 2.18138L5.00101 6.41099L0.760355 10.6516C0.371447 11.0405 0.371447 11.6769 0.760355 12.0659C1.14926 12.4548 1.78566 12.4548 2.17457 12.0659L6.4152 7.82522L10.6669 12.0769C11.0558 12.4658 11.6922 12.4658 12.0811 12.0769C12.47 11.688 12.47 11.0516 12.0811 10.6627Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExitCross);
export default __webpack_public_path__ + "static/media/ExitCross.40857888af86fc1811ed2193bb7ca694.svg";
export { ForwardRef as ReactComponent };